declare global {
  interface Window {
    _paq: Array<Array<unknown>>;
  }
}

export function initMatomo(matomoUrl: string, siteId: string) {
  if (!matomoUrl || !siteId) {
    return;
  }

  if (document.getElementById('matomo-script')) {
    return;
  }

  const url = matomoUrl.endsWith('/') ? matomoUrl : `${matomoUrl}/`;

  window._paq = window._paq || [];
  window._paq.push(['enableLinkTracking']);
  window._paq.push(['setTrackerUrl', `${url}matomo.php`]);
  window._paq.push(['setSiteId', siteId]);

  const script = document.createElement('script');
  script.id = 'matomo-script';
  script.async = true;
  script.src = `${url}matomo.js`;
  document.head.appendChild(script);
}

export function initUsetiful(
  token: string,
  userId?: string,
  groups?: string,
  language?: string,
  enabledRedistribution?: boolean,
  customerType?: string,
) {
  // <!-- User segmentation start -->
  if (userId) {
    // @ts-expect-error required by usetiful
    window.usetifulTags = {
      userId: userId,
      groups: groups,
      language: language,
      enabledRedistribution: enabledRedistribution,
      customerType: customerType,
    };
  }
  // <!-- User segmentation end -->
  // <!-- Usetiful script start -->
  (function (_w, d, s) {
    const a = d.getElementsByTagName('head')[0];
    const r = d.createElement('script');
    r.async = true;
    r.src = s;
    r.setAttribute('id', 'usetifulScript');
    r.dataset.token = token;
    a.appendChild(r);
  })(window, document, 'https://www.usetiful.com/dist/usetiful.js');

  // <!-- Usetiful script end -->
}

export function chatDisplay(status: boolean) {
  const omnicanal = document.getElementById(
    'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window',
  );
  if (omnicanal) {
    if (status) {
      omnicanal.style.display = 'block';
    } else {
      omnicanal.style.display = 'none';
    }
  }
}

export function initOmniCanal(
  chatId: string,
  token: string,
  primaryColor?: string,
) {
  if (!document.getElementById('customizeChatScript')) {
    const customizeScript = document.createElement('script');
    const color = primaryColor || '#FF0000';
    customizeScript.id = 'customizeChatScript';
    customizeScript.innerHTML = `
    function customizeChat() {
      return {
        chatButtonProps: {
          controlProps: {
              hideChatTextContainer: true,
          },
          styleProps: {
            generalStyleProps: {
              minWidth: "60px",
              width: "60px",
              height: "60px",
            },
            iconStyleProps: {
              backgroundColor: "${color}",
            }
          }
        },
        headerProps: {
          styleProps: {
            generalStyleProps: {
              backgroundColor: "${color}",
            }
          }
        },
        loadingPaneProps: {
          styleProps: {
            generalStyleProps: {
              backgroundColor: "${color}",
            }
          }
        }
      }
    }
  `;
    document.body.append(customizeScript);
  }

  if (!document.getElementById('Microsoft_Omnichannel_LCWidget')) {
    const script = document.createElement('script');
    script.setAttribute('v2', '');
    script.id = 'Microsoft_Omnichannel_LCWidget';
    script.src =
      'https://oc-cdn-ocfra-fra.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js';
    script.dataset.appId = chatId;
    script.dataset.lcwVersion = 'prod';
    script.dataset.orgId = '5e3f62df-f4c7-ed11-a10b-0022487242fa';
    script.dataset.orgUrl =
      'https://m-5e3f62df-f4c7-ed11-a10b-0022487242fa.fr.omnichannelengagementhub.com';
    script.dataset.customizationCallback = 'customizeChat';
    document.body.append(script);
  }

  if (!document.getElementById('Microsoft_Omnichannel_Auth')) {
    const scriptAuth = document.createElement('script');
    scriptAuth.id = 'Microsoft_Omnichannel_Auth';
    scriptAuth.innerHTML = `
      omnicanalAuth = async (callback) => {
        callback('${token}');
      }
    `;
    document.body.append(scriptAuth);
  }
}
